<template>
<div style="height: 10rem; overflow: scroll; width: 100%; flex-direction: column">
  <div style="height: 6rem; align-items: center; display: flex; width: 100%;" v-for="(item, index) in merchantList" :key="'n_' + index" @click="switchMerchant(item)">
    <div class="home-merchant-icon" :style="item.currentMerchant === true?null:{backgroundColor:'white'}"/>
    <el-image class="home-merchant-logo" :src="item.logo" fit="cover"/>
    <div class="home-merchant-name" :style="item.currentMerchant === true? {color: '#ff680a'}: null">{{item.name}}</div>
  </div>
</div>
</template>

<script>
import {switchMerchant} from './homeApi'

export default {
  name: 'switchMerchant',
  props: {
    currentMerchant: {
      type: Object,
      default: function () {
        return null
      }
    },
    merchantList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    switchMerchant (merchant) {
      const loading = this.$loading({
        lock: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const {merchantId} = merchant
      switchMerchant(merchantId).then(rsp => {
        loading.close()
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('切换成功')
          this.$emit('switchSuccess')
        } else {
          this.$message.error(message)
        }
      })
    }
  }
}
</script>

<style scoped>
.home-merchant-icon{
  width: 4px;
  height: 20px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  background-color: #409EFF;
}
.home-merchant-logo{
  margin-left: 10px;
  width: 60px;
  height: 60px;
  border-radius: 4px;
}
.home-merchant-name{
  font-size: 17px;
  width: 10rem;
  line-height: 4rem;
  height: 4rem;
  margin-left: 10px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/home/switchMerchant.vue